// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import {Typography} from '@material-ui/core';
import {colors} from '../../../../../assets/styles/colors';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';

type Props = {|
  text: string,
  selected?: boolean,
  handleOnClick: (id: any) => void,
  id: string,
|};

export const useStyles = makeStyles(theme => ({
  button: {
    padding: theme.spacing(0.375, 2),
    marginRight: theme.spacing(1),
    '&:last-child': {
      marginRight: theme.spacing(0),
    },
    border: '1px solid transparent',
    '&:hover': {
      border: '1px solid transparent',
    },
  },
  buttonSelected: {
    backgroundColor: '#F5F0FF',
  },
  optionText: {
    fontSize: 12,
    color: colors.grey700,
    textTransform: 'none',
  },
  selected: {
    color: colors.purple,
    fontWeight: 600,
  },
}));

export default function FilterButton(props: Props) {
  const {text, selected, handleOnClick, id} = props;
  const classes = useStyles();

  return (
    <CustomButton
      onClick={() => {
        handleOnClick(id);
      }}
      variant="outlined"
      className={`${classes.button} ${selected ? classes.buttonSelected : ''}`}
    >
      <Typography
        variant="body1"
        className={`${classes.optionText} ${selected ? classes.selected : ''}`}
      >
        {text}
      </Typography>
    </CustomButton>
  );
}

FilterButton.propTypes = {
  text: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  handleOnClick: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};
